module.exports = __webpack_public_path__ + "static/media/MBA.b165523f.JPG";